// extracted by mini-css-extract-plugin
export default {"title":"StudyTimer_title__2eOk1","content":"StudyTimer_content__mFoFH"};